import Vue from 'vue';

export class Concox{

    /**
     *
     * @param idRastreador
     * @returns {Promise}
     */
    static byPK(idRastreador){
        return new Promise((ok, fail) => {
            Vue.http.get('configuracao-concox/by-pk/' + idRastreador)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static sendTempos(json){
        return Vue.http.post('configuracao-concox/times', json);
    }

    static sendTemposAll(json){
        return Vue.http.post('configuracao-concox/times/all', json);
    }

    static habilitarTensao(idRastreador, enable){
        return Vue.http.post('configuracao-concox/habilitar-tensao', {
            id_rastreador: idRastreador,
            enable: enable
        });
    }

    static habilitarMtk(idRastreador, enable){
        return Vue.http.post('configuracao-concox/mkt', {
            id_rastreador: idRastreador,
            enable: enable
        });
    }

    static sendHbt(json){
        return Vue.http.post('configuracao-concox/hbt', json);
    }

    static sendHbtAll(json){
        return Vue.http.post('configuracao-concox/hbt/all', json);
    }

    static sendAngle(json){
        return Vue.http.post('configuracao-concox/angle', json);
    }

    static sendAngleAll(json){
        return Vue.http.post('configuracao-concox/angle/all', json);
    }

    static sendApn(json){
        return Vue.http.post('configuracao-concox/apn', json);
    }

    static sendIp(json){
        return Vue.http.post('configuracao-concox/ip', json);
    }

    static sendIpAll(json){
        return Vue.http.post('configuracao-concox/ip/all', json);
    }

    static sendFiltro(json){
        return Vue.http.post('configuracao-concox/filtro', json);
    }

}
